import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider } from '@/lib/auth/AuthProvider'
import { AppShell } from '@/components/layout/AppShell'
import { ProtectedRoute } from '@/routes/ProtectedRoute'
import { RedirectIfAuthenticated } from '@/routes/RedirectIfAuthenticated'
import { LoginPage } from '@/pages/LoginPage'
import { ChangePasswordPage } from '@/pages/ChangePasswordPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { ForbiddenPage } from '@/pages/ForbiddenPage'
import { GanttPage } from '@/pages/GanttPage'
import { SettingsLayout } from '@/pages/settings/SettingsLayout'
import { AirportsPage } from '@/pages/settings/AirportsPage'
import { AircraftPage } from '@/pages/settings/AircraftPage'
import { CityPairsPage } from '@/pages/settings/CityPairsPage'
import { CapabilityPage } from '@/pages/settings/CapabilityPage'
import { GroupsPage } from '@/pages/settings/GroupsPage'
import { TimezonesPage } from '@/pages/settings/TimezonesPage'
import { CountriesPage } from '@/pages/settings/CountriesPage'

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route
            path="/login"
            element={
              <RedirectIfAuthenticated>
                <LoginPage />
              </RedirectIfAuthenticated>
            }
          />

          <Route
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route
              path="gantt"
              element={
                <ProtectedRoute capability="schedule.view">
                  <GanttPage />
                </ProtectedRoute>
              }
            />
            <Route path="change-password" element={<ChangePasswordPage />} />
            <Route path="forbidden" element={<ForbiddenPage />} />

            <Route
              path="settings"
              element={
                <ProtectedRoute capability="settings.view">
                  <SettingsLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/settings/airports" replace />} />
              <Route path="airports" element={<AirportsPage />} />
              <Route path="aircraft" element={<AircraftPage />} />
              <Route path="city-pairs" element={<CityPairsPage />} />
              <Route path="capability" element={<CapabilityPage />} />
              <Route path="groups" element={<GroupsPage />} />
              <Route path="timezones" element={<TimezonesPage />} />
              <Route path="countries" element={<CountriesPage />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}
